import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Button,
    DialogContent,
    DialogTitle,
    DialogActions,
    Dialog,
    Grid,
    TextField
} from '@material-ui/core';

import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

function CreateNewUserGroupModal({ clientId, showModal, MODAL_TYPE }) {
    const [name, setName] = useState('');
    const { notifySuccess, notifyError } = useNotify();
    const history = useHistory();

    const createUserGroup = useCallback(() => {
        doSwaggerCall('usergroups', 'createUserGroup', {
            newUserGroup: {
                company_id: parseInt(clientId, 10),
                name
            }
        })
            .then(newUserGroup => {
                notifySuccess('New user group created!');
                showModal(MODAL_TYPE.NONE);
                history.push(`/admin/client/${clientId}/usergroups/${newUserGroup.id}`);
            })
            .catch(err => {
                console.log(err);
                notifyError('Error during user group creation!');
            });
    }, [name, notifySuccess, notifyError, showModal, history]);

    return (
        <form>
            <Dialog
                aria-labelledby="client-modal"
                open
                onClose={() => showModal(MODAL_TYPE.NONE)}
                maxWidth="md"
            >
                <DialogTitle>Create new user group</DialogTitle>
                <DialogContent>
                    <form
                        id="newusergroup-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            createUserGroup();
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    type="text"
                                    value={name}
                                    onChange={ev => setName(ev.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!name}
                        type="submit"
                        form="newusergroup-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default CreateNewUserGroupModal;
